/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_TitleInputs */



/**
* | output |
* | --- |
* | "Manual QC" |
*
* @param {Manual_Qc_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_title = /** @type {((inputs?: Manual_Qc_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("QC manuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Manuelle Qualitätskontrolle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controllo qualità manuale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ручной контроль качества")
	if (locale === "es") return /** @type {LocalizedString} */ ("Control de calidad manual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("人工质检")
	if (locale === "ja") return /** @type {LocalizedString} */ ("手動QC")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मैनुअल क्यूसी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Controle de qualidade manual")
	return /** @type {LocalizedString} */ ("Manual QC")
});